const stable_sort = (array, cmp) => {
  cmp =
    cmp || false
      ? cmp
      : (lhs, rhs) => {
          if (lhs < rhs) return -1;
          if (lhs > rhs) return 1;
          return 0;
        };
  let stabilizedThis = array.map((el, index) => [el, index]);
  let stableCmp = (lhs, rhs) => {
    let order = cmp(lhs[0], rhs[0]);
    if (order != 0) return order;
    return lhs[1] - rhs[1];
  };
  stabilizedThis.sort(stableCmp);
  return stabilizedThis.map(item => item[0]);
};

export default stable_sort;
